import { HStack, VStack } from '@chakra-ui/react'
import {
  faCircleInfo,
  faDollar,
  faStar,
} from '@fortawesome/free-solid-svg-icons'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { REPOSITORY } from '../../api/repository/Repository'
import Table from '../../components/Table/Table'
import Toast from '../../components/Toast/Toast'
import NumberBody from '../../components/Toast/ToastContents/NumberBody'
import UnderlineHeading from '../../components/UnderlineText/UnderlineHeading'
import { useLabels } from '../../utils/hooks/useLabels/useLabels'

const rechargesToBillColumns = [
  { id: 'fecha', Header: 'Fecha', type: 'date' },
  { id: 'Descripcion', Header: 'Descripción' },
  { id: 'Abono', Header: 'Abono', type: 'currency' },
  { id: 'Cargo', Header: 'Cargo', type: 'currency' },
]
const purchaseOrdersColumns = [
  { id: 'info', Header: 'Detalle', type: 'clickeable', keyValue: 'idOC' },
  { id: 'nOC', Header: 'N° OC' },
  { id: 'FechaOC', Header: 'Fecha OC', type: 'date' },
  { id: 'MontoNetoOC', Header: 'Monto NETO OC', type: 'currency' },
  { id: 'CupoEntregado', Header: 'Cupo entregado', type: 'currency' },
  { id: 'Descuento', Header: 'Descuento', type: 'currency' },
  { id: 'TotalOC', Header: 'Total OC', type: 'currency' },
  { id: 'MontoAsignado', Header: 'Monto asignado', type: 'currency' },
]
const historicalMovementsColumns = [
  { id: 'info', Header: 'Detalle', type: 'clickeable', keyValue: 'Documento' },
  { id: 'fecha', Header: 'Fecha', type: 'date' },
  { id: 'Documento', Header: 'N° de Documento' },
  { id: 'Descripcion', Header: 'Descripción' },
  { id: 'Abono', Header: 'Abono', type: 'currency' },
  { id: 'Cargo', Header: 'Cargo', type: 'currency' },
  { id: 'Estado', Header: 'Estado' },
]
const useAccountStatus = ({ onCLickHistorical, onClickOC }) => {
  const { texts } = useLabels()
  const [rechargesToBill, setRechargesToBill] = useState([])
  const [historicalMovements, setHistoricalMovements] = useState([])
  const [purchaseOrders, setPurchaseOrders] = useState([])

  const getData = useCallback(async () => {
    await REPOSITORY.wsEmpresa.company.getRechargesToBill().then((res) => {
      setRechargesToBill(res.data)
    })
    await REPOSITORY.wsEmpresa.company.getHistoryMovements().then((res) => {
      setHistoricalMovements(res.data)
    })
    await REPOSITORY.wsEmpresa.company.getPurchaseOrders().then((res) => {
      setPurchaseOrders(res.data)
    })
  }, [])

  useEffect(() => {
    getData()
  }, [getData])

  const historicalTable = useMemo(() => {
    return (
      <VStack h={'100%'} alignItems="flex-start" w="100%" spacing="40px">
        <UnderlineHeading text={texts.historical_movements} variant="h6" />
        <VStack alignItems="flex-start" w="100%" spacing="40px">
          <Table
            onEmployeeClick={onCLickHistorical}
            data={historicalMovements?.oMovFacturados || []}
            columns={historicalMovementsColumns}
          />
          <HStack w="100%" spacing="30px">
            <Toast variant="gray">
              <NumberBody
                title="Total abonos"
                number={
                  Number(historicalMovements?.oTotales?.nTotalAbonos || 0) || 0
                }
                icon={faStar}
              />
            </Toast>
            <Toast variant="gray">
              <NumberBody
                title="Total cargos"
                number={
                  Number(historicalMovements?.oTotales?.nTotalCargos || 0) || 0
                }
                icon={faDollar}
              />
            </Toast>

            <Toast variant="gray">
              <NumberBody
                title="Pediente por pagar"
                number={
                  Number(
                    historicalMovements?.oTotales?.nPendientePorPagar || 0,
                  ) || 0
                }
                icon={faCircleInfo}
              />
            </Toast>
          </HStack>
        </VStack>
      </VStack>
    )
  }, [onCLickHistorical, historicalMovements])
  const rechargesToBillTable = useMemo(() => {
    return (
      <VStack h={'100%'} alignItems="flex-start" w="100%" spacing="40px">
        <UnderlineHeading text={texts.recharges_to_bill} variant="h6" />
        <VStack alignItems="flex-start" w="100%" spacing="40px">
          <Table
            data={rechargesToBill?.oRecargaPorFacturar || []}
            columns={rechargesToBillColumns}
          />
          <Toast variant="gray">
            <NumberBody
              title="Total cargos"
              number={Number(rechargesToBill?.TotalCargos || 0) || 0}
              icon={faDollar}
            />
          </Toast>
        </VStack>
      </VStack>
    )
  }, [rechargesToBill])

  const purchaseOrdersTable = useMemo(() => {
    return (
      <VStack h={'100%'} alignItems="flex-start" w="100%">
        <UnderlineHeading text={texts.purchase_orders_detail} variant="h6" />
        <Table
          data={purchaseOrders || []}
          columns={purchaseOrdersColumns}
          onEmployeeClick={onClickOC}
        />
      </VStack>
    )
  }, [purchaseOrders])

  return { purchaseOrdersTable, historicalTable, rechargesToBillTable }
}

export default useAccountStatus
